import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { UpdateBankFormData } from "../schema/UpdateBankSchema";
import { UpdateBankResponseSchema } from "../response/UpdateBankResponse";
import { ValidationErrorResponse } from "../../common/response/ValidationErrorResponse";

export const useUpdateBank = () => {
    return useMutation({
        mutationFn: async (values: {
            bankId: string;
            formData: UpdateBankFormData;
        }) => privateApi.put(`/v3/property-bank/${values.bankId}`, values.formData),
        onSuccess: async (response) => {
            try {
                const validationResult = UpdateBankResponseSchema.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid update bank data format");
                }

                return validationResult.data;
            } catch (error) {
                console.error('Failed to update bank', error);
                throw error;
            }
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid bank data format");
            } else {
                console.error('Failed to update bank', error);
                throw error;
            }
        },
    });
};